import { FC } from 'react'
import PerIcon from '../../../components/custom_components/Icon'
import PerText from '../../../components/custom_components/Text'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import type { IconNames } from '../../../components/util/types'
import { Spin } from 'antd'
import { countIntegerDigits } from '../utils/dashboardHeaderCountersUtil'

type DashboardCounterWidgetHeaderProps = {
  icon: IconNames
  totalValue: number
  labelFirstLine: string
  labelSecondLine: string
  countersAvailable: boolean
  loading: boolean
  onClick?: () => void
  openDetailsAria?: string
}

const DashboardCounterWidgetHeader: FC<DashboardCounterWidgetHeaderProps> = ({
  icon,
  totalValue,
  labelFirstLine,
  labelSecondLine,
  countersAvailable,
  loading,
  onClick,
  openDetailsAria,
}) => {
  const showIcon = countIntegerDigits(totalValue) < 4

  const content = (
    <PerFlexRow justify="start" align="middle" noWrap width="fullWidth">
      {showIcon ? <PerIcon name={icon} size={20} color="primary" /> : null}

      <PerText fontSize={countersAvailable || loading ? 'xl' : 's'} fontWeight="bold" mr="xxxs" ml={showIcon ? 'xxxs' : 'none'}>
        {countersAvailable ? totalValue : loading ? <Spin size="small" /> : 'N/A'}
      </PerText>

      <PerFlexRow direction="column" justify="center" align="top">
        <PerText transform="uppercase" fontSize="xs">
          {labelFirstLine}
        </PerText>
        <PerText transform="uppercase" fontSize="xs">
          {labelSecondLine}
        </PerText>
      </PerFlexRow>
    </PerFlexRow>
  )

  if (!onClick) {
    return content
  }

  return (
    <div
      className="dashboard-hc__main-stat--clickable"
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={openDetailsAria}
    >
      {content}
    </div>
  )
}

export default DashboardCounterWidgetHeader
